import { AxiosPromise } from 'axios';
import grispiApi from '../../apis/grispiApi';
import { BulkTicketActivities } from '../TicketActivityIndicator';

const LOG_LABEL = 'TicketActivityHelper';
function navigateAwayFromTicket(ticketKey: string): void {
    // No need to return promise for this one. Just call and forget.
    // Don't use shouldMakeAQueryNow for this one so make sure activity is deleted called any time
    // For example, as a result of a bug, when a ticket tab is closed it fires 'TicketOpened' event from 'TicketFormEventListener' just before closing.
    // This might result in writing the activity after calling 'navigateAwayFromTicket' from 'TicketFormEventListener' would be ignored and the activity
    // won't be deleted.
    // If we use 'shouldMakeAQueryNow' then 'navigateAwayFromTicket' call from
    grispiApi
        .delete(`/tickets/${ticketKey}/activity`)
        .then((response) => console.debug(LOG_LABEL, `navigateAwayFromTicket ${ticketKey}`, response.status))
        .catch((reason) => console.error(LOG_LABEL, `navigateAwayFromTicket ${ticketKey}`, 'failed', reason));
    //FIXME destan: ask cagri: how to handle error here? can we repeat it?
}

// TODO: performance optimization, should have bulk version of this request
function visitingTicket(ticketKey: string): void {
    const url = `/tickets/${ticketKey}/activity/visiting`;

    grispiApi
        .post(url)
        .then((response) => console.debug(LOG_LABEL, `visitingTicket ${ticketKey}`, response.status))
        .catch((reason) => console.error(LOG_LABEL, `visitingTicket ${ticketKey}`, 'failed', reason));
}

// TODO: performance optimization, should have bulk version of this request
function editingTicket(ticketKey: string): void {
    const url = `/tickets/${ticketKey}/activity/editing`;

    grispiApi
        .post(url)
        .then((response) => console.debug(LOG_LABEL, `editingTicket ${ticketKey}`, response.status))
        .catch((reason) => console.error(LOG_LABEL, `editingTicket ${ticketKey}`, 'failed', reason));
}

// export function getActivitiesForTicket(ticketKey: string): Promise<AxiosResponse> {
//     return grispiApi.get(`/tickets/${ticketKey}/activity`);
// }

function getBulkActivitiesForTickets(ticketKeyListString: string): AxiosPromise<BulkTicketActivities> {
    return grispiApi.get(`/tickets/${ticketKeyListString}/activities`);
}

function callLifecycleIfNotNewTicket(cb: (ticketKey: string) => void, relatedTicketKey: string) {
    return (e: CustomEvent) => {
        const ticketKey = e.detail;
        if (!ticketKey.startsWith('newTicket') && relatedTicketKey === ticketKey) {
            cb(ticketKey);
        }
    };
}

export {
    callLifecycleIfNotNewTicket,
    editingTicket,
    getBulkActivitiesForTickets,
    navigateAwayFromTicket,
    visitingTicket
};
